var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!!_vm.job?.documents_signed_manually)?_c('span',[_c('span',{staticClass:"badge badge-success"},[_vm._v("Documents Signed In Person")])]):_c('span',{class:_vm.statusClass},[_vm._v("\n    "+_vm._s(_vm.statusText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }